"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsForceAccountSchema = void 0;
const joi_1 = __importDefault(require("joi"));
/**
 * This is only a slice of SF data. If you need more, add more
 */
exports.JsForceAccountSchema = joi_1.default.object({
    Account_Status__c: joi_1.default.string().allow(null),
    Id: joi_1.default.string().required(),
    Account_UUID__c: joi_1.default.string().uuid().required(),
    BillingAddress: joi_1.default.object({
        city: joi_1.default.string().allow(null),
        country: joi_1.default.string().allow(null),
        countryCode: joi_1.default.string().allow(null),
        geocodeAccuracy: joi_1.default.string().allow(null),
        postalCode: joi_1.default.string().allow(null),
        state: joi_1.default.string().allow(null),
        stateCode: joi_1.default.string().allow(null),
        street: joi_1.default.string().allow(null),
        latitude: joi_1.default.number().allow(null),
        longitude: joi_1.default.number().allow(null)
    }).required(),
    Calender_ID__c: joi_1.default.string().allow(null),
    Email_Calendar__c: joi_1.default.string().allow(null),
    Email_Personal__c: joi_1.default.string().allow(null),
    // Photographer specific
    Amount_of_Free_Km__c: joi_1.default.number().allow(null),
    Cost_per_kilometre__c: joi_1.default.number().allow(null),
    Wage_Per_Hour__c: joi_1.default.number().allow(null),
    CurrencyIsoCode: joi_1.default.string().allow(null),
    First_Name__c: joi_1.default.string().allow(null),
    Language_of_communication__c: joi_1.default.string().allow(null),
    Mobile_Phone__c: joi_1.default.string().allow(null),
    Mobility_by_Car__c: joi_1.default.string().allow(null),
    Name: joi_1.default.string().required(),
    Notify_Location__c: joi_1.default.boolean().allow(null),
    Photographer_Equipment__c: joi_1.default.string().allow(null),
    Photographer_Skills__c: joi_1.default.string().allow(null),
    Last_Engaged_Date_Time__c: joi_1.default.string().allow(null),
    // Customer specific
    Pre_Agreed_Payment__c: joi_1.default.string().allow(null)
})
    .unknown(true)
    .meta({ className: 'JsForceAccount' });
//# sourceMappingURL=JsForceAccountSchema.js.map